import { render, staticRenderFns } from "./AddDesignation.vue?vue&type=template&id=6e7533ac&"
import script from "./AddDesignation.vue?vue&type=script&lang=js&"
export * from "./AddDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7533ac')) {
      api.createRecord('6e7533ac', component.options)
    } else {
      api.reload('6e7533ac', component.options)
    }
    module.hot.accept("./AddDesignation.vue?vue&type=template&id=6e7533ac&", function () {
      api.rerender('6e7533ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/AddDesignation.vue"
export default component.exports